import React from "react";

import { DashboardEditorProps } from "components/ComponentTypeTypes";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { DATE_PATTERN_MINUTES } from "utils/constants";
import InputLabelWrapper from "components/basic/input-label-wrapper/InputLabelWrapper";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { T } from "services/lang/LanguageService";
import CommonChartEditor from "../../CommonChartEditor";
import { DatasetBarChartRendererProps } from "../../interfaces";
import { CategoryPatternOptions, DateFormat, DatePatternOptions, XAxisType, XAxisTypeOptions } from "../bar-chart-utils";

function DatasetBarChartEditor({ config, onConfigChange }: DashboardEditorProps<DatasetBarChartRendererProps>) {
  const handleConfigChange = (e: DropdownChangeEvent | InputSwitchChangeEvent): void => {
    onConfigChange({ ...config, [e.target.id]: e.value });
  };

  return (
    <>
      <div className="flex flex-row gap-3 mb-3">
        <InputLabelWrapper labelName={T("label.select-x-axis-type")} col={3}>
          <Dropdown
            value={config.xAxisType ?? XAxisType.DATE}
            options={XAxisTypeOptions}
            onChange={e => onConfigChange({ ...config, xAxisType: e.value, dateFormat: undefined })}
            placeholder={T("word.select-one")}
            className="p-inputtext-sm"
          />
        </InputLabelWrapper>
        <InputLabelWrapper labelName={T("component.date-format")} col={3}>
          <Dropdown
            value={config.dateFormat ?? (config.xAxisType === XAxisType.CATEGORY ? DATE_PATTERN_MINUTES : DateFormat.MINUTES)}
            options={config.xAxisType === XAxisType.CATEGORY ? CategoryPatternOptions : DatePatternOptions}
            onChange={handleConfigChange}
            placeholder={T("word.select-one")}
            editable
            className="p-inputtext-sm"
          />
        </InputLabelWrapper>
        <div className="flex flex-column gap-2 w-3">
          <label htmlFor="isStacked">{T("word.stacked")}</label>
          <InputSwitch id="isStacked" checked={config.isStacked ?? false} onChange={handleConfigChange} />
        </div>
        <div className="flex flex-column gap-2 w-3">
          <label htmlFor="hideBarLabels">{T("action.hide-bar-labels")}</label>
          <InputSwitch id="hideBarLabels" checked={config.hideBarLabels ?? false} onChange={handleConfigChange} />
        </div>
      </div>
      <CommonChartEditor config={config} onConfigChange={onConfigChange} />
    </>
  );
}
export default DatasetBarChartEditor;
